import type { FeedbackStatus } from "@/domain/feature-announcement-feedback"

/**
 * Client-side friendly label, mirroring the domain `toFriendlyFeedbackStatus`.
 * The list RPC also sends `friendlyStatus`, but the THREAD's feedback projection
 * carries only the raw `status`, so the badge derives its own label here. The
 * exhaustiveness check keeps both copies in lockstep if the status set grows.
 */
export function friendlyFeedbackStatus(status: FeedbackStatus): string {
  switch (status) {
    case "new":
      return "Received"
    case "reviewing":
      return "Under review"
    case "planned":
      return "Planned"
    case "shipped":
      return "Shipped"
    default: {
      const _exhaustive: never = status
      return _exhaustive
    }
  }
}

/**
 * Maps a triage status to a GlowStatusBadge tone (badge colour only).
 *
 * The explicit four-arm switch (no `default`) means a new FeedbackStatus is a
 * compile error here via the `never` exhaustiveness check.
 */
export type BadgeTone = "info" | "brand" | "warning" | "success"

export function feedbackStatusTone(status: FeedbackStatus): BadgeTone {
  switch (status) {
    case "new":
      return "info"
    case "reviewing":
      return "brand"
    case "planned":
      return "warning"
    case "shipped":
      return "success"
    default: {
      const _exhaustive: never = status
      return _exhaustive
    }
  }
}
